import {
  Theme,
  Switch as MuiSwitch,
  withStyles,
  createStyles,
  SwitchClassKey,
  SwitchProps,
} from "@material-ui/core";

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

type Props = {
  classes: Styles;
} & SwitchProps;

export const Switch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 44,
      height: 24,
      padding: 0,
    },
    switchBase: {
      padding: 2,
      "&$checked": {
        color: theme.palette.common.white,

        transform: "translateX(20px)",
        "& + $track": {
          opacity: 1,

          backgroundColor: theme.palette.primary.main,
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: theme.palette.primary.main,
      },
    },
    thumb: {
      width: 20,
      height: 20,

      backgroundImage: "linear-gradient(to top, #ededed, #ffffff)",
      boxShadow: "0 2px 4px 0 rgba(137, 137, 137, 0.37)",
    },
    track: {
      opacity: 1,

      borderRadius: 24 / 2,
      backgroundColor: theme.palette.gunmetal.main,

      transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
  }),
)(({ classes, ...rest }: Props) => (
  <MuiSwitch
    aria-label="switch"
    {...rest}
    focusVisibleClassName={classes.focusVisible}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
  />
));
